import _ from 'lodash'
import L3Title from '../l3/L3Title'
import { useConcept } from '../../../redux/selectConcept'
import { useFormSelector } from '../../../redux/formStoreHooks'
import { ValidityDeterminate, RenderMedia } from '@fusion-advantage/backcompat'
import { useConceptStatusValidity } from '../../../redux/selectConceptStatus2'

interface L4TitleProps {
	cid?: string
	tier?: string|number
	title?: string
}

const L4Title = ({cid, tier = 3, title}: L4TitleProps) => {
	const media = useFormSelector(state => state.render.media)
	const concept = useConcept(cid)
	const validity = useConceptStatusValidity(cid)
	let tierInt: number = _.isString(tier) ? parseInt(tier) : tier

	return (
		<L3Title
			required={validity?.determinate === ValidityDeterminate.Required}
			tier={tierInt}
			title={title}
			concept={concept ?? undefined}
			print={media === RenderMedia.Print}
		/>
	)
}

export default L4Title
